var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('img',{attrs:{"src":require("@/assets/img/time-icon-b.svg"),"alt":"시간 아이콘"}}),_c('p',[_vm._v(_vm._s(_vm.course.startDate)+"("+_vm._s(_vm.course.day)+") "+_vm._s(_vm.course.start_time)+"~"+_vm._s(_vm.course.end_time)+" ("+_vm._s(_vm.course.time)+"분)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }